import * as addressService from "@hub/simulator/src/services/address.service"
import { ADDRESS_GROUP_COMPLEMENT_TYPE } from "@hub/order/src/constants"

export default {
  fillAddress({ commit, state }, address) {
    commit("setCep", address.cep)
    commit("setAddress", address.address)
    commit("setNumber", address.number)
    commit("setNoNumber", address.noNumber)
    commit("setNeighborhood", address.neighborhood)
    commit("setState", address.state)
    commit("setCity", address.city)
    commit("setCityId", address.cityId)
    commit("setLatitude", address.latitude)
    commit("setLongitude", address.longitude)
    commit("setStateId", address.stateId)
    commit("setLocationType", address.locationType)
    commit("setReferencePoint", address.referencePoint)
    commit(
      "setSecondaryAddress",
      address.secondaryAddress || [{ type: "", text: "", value: "" }]
    )
    commit("setCondominiumComplement", address.condominiumComplement || state.condominiumComplement)

    commit(
      "setComplement",
      address.complement === null || address.complement === undefined || !Array.isArray(address.complement)
        ? []
        : address.complement.filter(
            complement => complement.type !== ADDRESS_GROUP_COMPLEMENT_TYPE
          )
    )
    
    if (address.complement && Array.isArray(address.complement)) {
      address.complement.forEach(complement => {
        if (complement.type === ADDRESS_GROUP_COMPLEMENT_TYPE) {
          commit("updateAddressGroupUnity", complement.value)
          commit("updateAddressGroupUnityName", complement?.label)
          commit("updateAddressGroupDescription", complement.type)
        }
      })
    }
  },
  deleteComplement({ commit, getters }, indexComplement) {
    const newComplements = getters.getComplements.filter(
      (complement, index) => index !== indexComplement
    )
    commit("setComplement", newComplements)
  },
  createComplement({ commit, getters }, newComplement) {
    const newComplements = getters.getComplements
    newComplements.push(newComplement)

    commit("setComplement", newComplements)
  },

  async fetchAddressByUserPosition({ commit, getters }) {
    if (
      (!getters.getCurrentLatitude && !getters.getCurrentLongitude) ||
      getters.getHasMadeCepFromCurrentLocationRequest
    ) {
      return
    }

    const params = {
      latitude: getters.getCurrentLatitude,
      longitude: getters.getCurrentLongitude
    }

    try {
      const { data } = await addressService.fetchAddressByUserPosition(params)

      if (data) {
        commit("setCepForCurrentLocation", data?.address?.postcode)
        return
      }
    } catch (error) {
      console.error(error)
    } finally {
      commit("setHasMadeCepFromCurrentLocationRequest", true)
    }
  }
}
